import FlowNode from './flowNode.js';

class PageNode extends FlowNode {
  constructor(id, data) {
    super(id, data);
    this.template = data.template;
    this.handler = data.handler;
    this.providers = data.providers;
    this.variables = data.variables;
  }

  getTemplate() {
    return this.template;
  }

  getHandler() {
    return this.handler;
  }
}

export default PageNode;
